import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useStartAPetitionPageState } from '#src/app/pages/startAPetitionV2/pageContext';

type UseErrorScreenReturn = ModelHookResult<undefined, { handlePrimaryActionClick: () => void }>;

export function useErrorScreen(): UseErrorScreenReturn {
	const { actions } = useStartAPetitionPageState();
	const track = useTracking();

	const startFromScratch = useCallback(() => {
		actions.send({ type: 'error' });
	}, [actions]);

	const handlePrimaryActionClick = useCallback(() => {
		void track('sap_ai_draft_error_restart');
		startFromScratch();
	}, [track, startFromScratch]);

	return {
		actions: {
			handlePrimaryActionClick,
		},
	};
}
